var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.653 20.143 45.743 8.23c3.603-1.258 7.37 1.416 7.37 5.232V23.74h4.691a5.542 5.542 0 0 1 5.542 5.542v7.181a5.543 5.543 0 0 1 4.75 5.486v6.333a5.543 5.543 0 0 1-4.75 5.486v8.764a5.542 5.542 0 0 1-5.542 5.542H13.471a5.542 5.542 0 0 1-5.542-5.542v-33.25c0-3.225-.43-7.688 3.724-9.14Zm4.104 3.597h32.606V13.463a.792.792 0 0 0-1.053-.747L15.757 23.74Zm-2.286 4.75a.792.792 0 0 0-.792.792v33.25c0 .437.355.792.792.792h44.333a.792.792 0 0 0 .792-.792v-8.708h-8.708a8.708 8.708 0 0 1 0-17.417h8.708v-7.125a.792.792 0 0 0-.792-.792H13.471Zm36.417 12.667a3.958 3.958 0 1 0 0 7.917h12.666a.792.792 0 0 0 .792-.792v-6.333a.792.792 0 0 0-.792-.792H49.888Z",
    fill: "currentColor"
  })));
};
export default SvgWallet;